import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { INCOMING_MAIL_STATUSES, MAIL_CLASSIFICATION_STATUS } from "src/utils/constants/constants";
import { Props, IncomingMailCombinedStatusOptionValue, IncomingMailCombinedStatusQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const IncomingMailCombinedStatusQuickfilter = <Q extends IncomingMailCombinedStatusQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.incoming_mail_status"; // tRP - translation root path

  const options: QuickFilterOption<IncomingMailCombinedStatusOptionValue>[] = [
    {
      name: t("common_words.all"),
      value: {
        statusIds: [],
      },
    },
    {
      name: t(`${tRP}.requiring_classification`),
      value: {
        statusIds: [MAIL_CLASSIFICATION_STATUS.ToBeClassified.id],
      },
    },
    {
      name: t(`${tRP}.requiring_emailing`),
      value: {
        statusIds: [INCOMING_MAIL_STATUSES.Pending.id],
      },
    },
  ];

  const getMultipleSelectionLabel = useCallback(
    (value: Q["incomingMailCombinedStatus"][keyof Q["incomingMailCombinedStatus"]][] | string[][]): string | null => {
      const flattenedValues = value.flat(2);

      if (
        flattenedValues.includes(INCOMING_MAIL_STATUSES.Pending.id) &&
        flattenedValues.includes(MAIL_CLASSIFICATION_STATUS.ToBeClassified.id)
      ) {
        return t(`${tRP}.requiring_actions`);
      } else return null;
    },
    []
  );

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="incomingMailCombinedStatus"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
      isMultiSelect
      multiSelectField="statusIds"
      getMultipleSelectionLabel={getMultipleSelectionLabel}
    />
  );
};
